// extracted by mini-css-extract-plugin
module.exports = {"cdcxapv":"cdcxapv","ccklfof":"ccklfof","p1lsnxoh":"p1lsnxoh"};